import { defineStore } from "pinia";
import { bindApi } from "@/api";
import { GAME_ID } from "@/stores";

export const useBindStore = defineStore("bind", {
  state: () => ({
    serverList: [],
    recentServerList: [],
    roleList: [],
  }),
  actions: {
    async getServerList() {
      const response = await bindApi.getServerList(GAME_ID);
      this.serverList = response.data.all_servers || [];
      this.recentServerList = response.data.recent_servers || [];
    },
    async getRoleList(server_id: string | number) {
      const response = await bindApi.getRoleList(GAME_ID, server_id);
      this.roleList = response.data;
    },
    async bindRole(
      server_id: string | number,
      role_id: string | number,
      server_name: string,
      role_name: string
    ) {
      const response = await bindApi.bindRole(
        GAME_ID,
        server_id,
        role_id,
        server_name,
        role_name
      );
      if (response.code == 200) {
        return true;
      } else {
        return false;
      }
    },
  },
});
